import { useParams } from 'react-router-dom';

import { Navigate } from '~/components/utils/Navigation';

export const AppSubscriptionSuccessSettingsRoute: React.FC = () => {
  const { appId } = useParams();

  if (!appId) {
    return <Navigate to="/" />;
  }

  return <Navigate to={`/apps/${appId}`} />;
};
